import { Col } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGlobalFilterContext } from "../../../../../contexts/GlobalFilterProvider";
import Theme from "../../../../../styles/Theme/Theme";
import { getColorBySeverity } from "../../../../../utils/hooks/getColorByPriority";
import { groupBy } from "../../../../../utils/hooks/gourpBy";
import { isLogItem } from "../../../../../utils/hooks/logItems";
import { Widget } from "../../../Atomics/Widget";

/**
 * Componente IncidentsOverlay
 * Renderiza um widget que mostra o número de eventos em um gráfico de várias barras horizontais
 */

export const LeftIncidentsOverlay = ({ mapPois }) => {
  const { t } = useTranslation(); // Hook de tradução do react-i18next

  const { setSeveritiesSelected, dropdownSeverities } = useGlobalFilterContext();

  /**
   * Handles the click event on a slice.
   * Uses setTimeout to defer the state update until after ApexCharts finishes its own click handling,
   * avoiding internal timing issues that can lead to “getAttribute of null” errors.
   * 
   * @param {Object} slice - The slice object that was clicked.
   * @param {string} slice.id - The unique identifier of the slice.
   * 
   * @returns {void}
   */
  const onSliceClick = (slice) => {
    if (slice?.id) {
      setTimeout(() => {
        setSeveritiesSelected([{ label: slice.id, value: slice.id }]);
      }, 0);
    }
  }


  /**
   * Serializes the number of log items from the given data.
   * @param {Array} data - The data containing log items.
   * @returns {Object} An object with the number of log items, unit, and icon.
   */
  const serializeNumberOfLogItems = (data) => {
    const logItemsCount = data?.filter((item) => isLogItem(item))?.length || 0;

    return {
      number: logItemsCount,
      unit: "Log Items",
      icon: "Information",
      iconColor: Theme.color["log-item"],
      iconButton: true,
      onIconButtonClick: () => {
        setSeveritiesSelected([]);
      }
    }
  }

  /**
   * Serializes the number of incidents based on their severity.
   *
   * @param {Array} data - The array of incident data to be serialized.
   * @returns {Object} The serialized data containing series, categories, tooltip, and other properties.
   */
  const serializeNumberOfIncidents = (data) => {
    const series = [];
    var hasValue = false;
    var total = 0;

    const priorities = dropdownSeverities
      ?.map((severity) => severity.value)
      .sort((a, b) => parseInt(b.split(" - ")[0]) - parseInt(a.split(" - ")[0])) || [];

    const groupedBySeverity = groupBy(data, "severity");

    priorities.map((severity, index) => {
      const value = groupedBySeverity[severity] || [];
      total += value.length;
      if (hasValue === false && value.length > 0) hasValue = true;

      series.push({
        id: severity,
        name: severity,
        value: value.length ?? 0,
        color: getColorBySeverity(severity)
      });
    });

    return {
      "series": hasValue ? series : [{
        "name": "Energia estacionária",
        "value": 1,
        color: "coolgray-2"
      }],
      "categories": [],
      "tooltip": null,
      "markerSize": 3,
      "unit": "",
      "filename": "Gráfico exportado",
      "headerValue": "valores",
      "headerCategory": "categorias",
      "total": hasValue ? total : "0",
      "noDecimal": true,
      "customScale": 0.8,
      dataLabelsOffset: 42,
      sideLegend: true,
      disableToolbar: true,
      disableDataLabels: true,
      "noDataContent": "0 Issues",
      "disableTooltip": !hasValue ?? true,
      "hideLegends": !hasValue ?? true,
      centerVerticalLegend: true,
      onSliceClick,
      pieExpandOnClick: false,
      stateActiveFilterType: "none",
    };
  };

  return (
    <>
      {mapPois &&
        <>
          <Col span={24} className="overlay-widget">
            <Widget
              data={{
                background: "white", // Define o fundo do widget como branco
                title: t("Issues Number"), // Título do widget traduzido
                icon: null, // Nenhum ícone definido para o widget
                activeShadow: true,
                charts: [
                  {
                    chartType: "simpleDonutChartApex", // Tipo do gráfico
                    // chartId: "simpleDonutChartApexOne", // ID do gráfico
                    height: "210px", // Altura do gráfico
                    data: serializeNumberOfIncidents(mapPois),
                  },
                ],
              }}
            />
          </Col>
          <Col span={24} className="overlay-widget">
            <Widget
              data={{
                background: "white",
                title: t("title.log_items_number"),
                activeShadow: true,
                charts: [
                  {
                    chartType: "bigNumberChart",
                    height: "50px",
                    data: serializeNumberOfLogItems(mapPois),
                  }
                ],
              }}
            />
          </Col>
        </>
      }
    </>
  );
};